import type { ReactElement } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '../features/auth/components/require-auth';
import { AuthCallbackPage } from '../features/auth/pages/auth-callback-page';
import { LoginPage } from '../features/auth/pages/login-page';
import { AppShell } from '../features/shell/components/app-shell';
import { ROUTES } from '../shared/constants/app.constant';
import { NotFoundPage } from './not-found-page';

export interface PageElements {
  readonly dashboard: ReactElement;
  readonly transactions: ReactElement;
  readonly settings: ReactElement;
  readonly profile: ReactElement;
  readonly join: ReactElement;
}

// Struktur rute dipisah dari cara memuat halaman: aplikasi memakai lazy (code-split),
// test memakai impor langsung agar tidak bergantung pada timeout transformasi modul di jsdom.
export function buildRoutes(pages: PageElements): RouteObject[] {
  return [
    { path: ROUTES.login, element: <LoginPage /> },
    { path: ROUTES.authCallback, element: <AuthCallbackPage /> },
    { path: ROUTES.join, element: pages.join },
    {
      element: <RequireAuth />,
      children: [
        {
          element: <AppShell />,
          children: [
            { index: true, element: pages.dashboard },
            { path: ROUTES.transactions, element: pages.transactions },
            { path: ROUTES.settings, element: pages.settings },
            { path: ROUTES.profile, element: pages.profile },
          ],
        },
      ],
    },
    { path: '*', element: <NotFoundPage /> },
  ];
}
